import { ApiGetRatesParams, ApiGetRatesResponse, axios } from 'src/api'

export const ApiGetRates = ({ serverPath, data }: ApiGetRatesParams) => {
  return axios.post<ApiGetRatesResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/getrates`,
    data
  )
}
